export default "__VITE_ASSET__D0qsOLY0__"